import styled from '@emotion/styled'
import theme from '../../../../../../styles/theme'
import {
  InfoLarge600Style,
  InfoLarge700Style,
} from '../../../../../../styles/Text.styles'

export const PlotContainer = styled.div`
  width: 70%;
  flex-shrink: 0;
`

export const ChartContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1.2rem 0rem 1rem 1.3rem; /* Reduced left/right padding by 70% from 20px to 6px */
  overflow: auto; /* Allow horizontal scrolling if needed */
  box-sizing: border-box;
  width: 100%;
  height: 31rem;
  min-height: 400px; /* Ensure minimum height for usability */
  margin-bottom: 2rem;
`

export const ChartLegend = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
  padding: 0 5rem;
`

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #333;
  font-weight: ${(props) => (props.isBaseline ? 'bold' : 'normal')};
`

export const LegendLine = styled.div`
  width: 20px;
  height: ${(props) => (props.isBaseline ? '6px' : '4px')};
  background-color: ${(props) => props.color};
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: ${(props) => (props.isBaseline ? '12px' : '10px')};
    height: ${(props) => (props.isBaseline ? '12px' : '10px')};
    background-color: ${(props) => props.color};
    border: 2px solid #fff;
    border-radius: 50%;
  }
`

export const ChartTitle = styled.div`
  width: 98%;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 15px;
  padding-top: 10px;
  span {
    ${InfoLarge600Style}
    color: ${theme.colors.veryFadedText};
  }
`

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 1rem;
  padding: 4rem;
`

export const ErrorTitle = styled.h3`
  ${InfoLarge700Style}
`

export const ErrorDescription = styled.p`
  ${InfoLarge600Style}
`
